import React, { Component } from 'react';
import IconsContainer from "Utils/IconsContainer";
import { Transition, animated } from 'react-spring';
import 'Styles/commonComponents/FilterBlock.scss';

export default class FilterBlock extends Component {

    constructor() {
        super();

        this.state = {
            opened: true,
            openCloseAnimationInProgress: false
        };
    }

    setOpenState() {
        if (this.props.isMinimizeEnabled) {
            this.setState({ opened: !this.state.opened });

            if (this.props.onToggle != null)
                this.props.onToggle();
        }
    }

    render() {
        let clearButton = this.props.showCleanButton ? (
            <div className="clear-filter-button"
                onClick={this.props.clear}>
                {IconsContainer.Get('ci-cross')}
            </div>
        ) : '';

        let elements = (
            <div className="filter-content"
                key="filter-content">
                {this.props.children}
            </div>
        );

        let collapsedHeightPx = this.props.collapsedHeightPx > 0 ? this.props.collapsedHeightPx : 220;

        return (
            <div className={'filter-block' + ' ' + (this.props.className == null ? '' : this.props.className)}>
                <div className={"filter-title " + (this.props.isMinimizeEnabled ? "clickable" : "")}>
                    <div onClick={this.setOpenState.bind(this)} className="title-with-toggle-button">
                        {
                            this.props.isMinimizeEnabled
                                ?
                                <div className="toggle-button-container">
                                    <div className={"toggle-button" + (this.state.opened ? " opened" : '')}>
                                        {IconsContainer.Get('ci-arrow-down')}
                                    </div>
                                </div>
                                : ""
                        }
                        {this.props.title}
                        {(this.props.selectCount > 0 ? ' (' + this.props.selectCount + ')' : '')}
                    </div>
                    {clearButton}
                </div>
                {
                    this.props.isAnimated
                        ? (
                            <Transition
                                items={this.state.opened}
                                from={{ height: 0 }}
                                enter={{ height: collapsedHeightPx }}
                                leave={{ height: 0 }}
                                delay={0}
                                onStart={_ => this.setState({ openCloseAnimationInProgress: true })}
                                onRest={_ => this.setState({ openCloseAnimationInProgress: false })}>
                                {(styles, item) =>
                                    item && <animated.div style={styles}
                                        className={`filter-animation-content ${(this.state.openCloseAnimationInProgress) ? 'animationInProgress' : ''}`}>
                                        {elements}
                                    </animated.div>
                                }
                            </Transition>
                        )
                        : (
                            <div className="filter-static-content">
                                {elements}
                            </div>
                        )
                }
            </div>
        )
    }
}